export default "__VITE_ASSET__CnE7u1BJ__"